var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"dialog-overlay",on:{"click":_vm.close}},[_c('div',{staticClass:"dialog-content flex-center",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"mr-12"},[_vm._v(_vm._s(_vm.message))]),_c('dot')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }